module.exports = __webpack_public_path__ + "bac9714c0a3e97e3df0a4c6cbaef7ed2.pdf";